import { render, staticRenderFns } from "./ChangeLogo.vue?vue&type=template&id=2a8a27dc&scoped=true"
import script from "./ChangeLogo.vue?vue&type=script&lang=js"
export * from "./ChangeLogo.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogo.vue?vue&type=style&index=0&id=2a8a27dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a27dc",
  null
  
)

export default component.exports